import { render, staticRenderFns } from "./BookListPage.vue?vue&type=template&id=aaaba2a2"
import script from "./BookListPage.vue?vue&type=script&lang=js"
export * from "./BookListPage.vue?vue&type=script&lang=js"
import style0 from "./BookListPage.vue?vue&type=style&index=0&id=aaaba2a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports